import fetchUPlus from "../httpFetchCourse";
const ULSVC = "/uplus/ulsvc/v2";
const PUBLICSVC = "/uplus/publicsvc/v2";
// 我的学习信息
export function getMyLearning4ss(data) {
  return fetchUPlus.post(`${ULSVC}/getMyLearning4ss`, data);
}
// 用户排名
export function getRankList4ss(data) {
  return fetchUPlus.post(`${ULSVC}/getRankList4ss`, data);
}
// 我的机构的学习信息
export function getMyOrgLearning4ss(data) {
  return fetchUPlus.post(`${ULSVC}/getMyOrgLearning4ss`, data);
}
// 机构排行榜
export function getOrgRankList4ss(data) {
  return fetchUPlus.post(`${ULSVC}/getOrgRankList4ss`, data);
}
// 我在机构中的学习信息
export function getMyLearningInOrg4ss(data) {
  return fetchUPlus.post(`${ULSVC}/getMyLearningInOrg4ss`, data);
}
// 我的机构用户排行榜
export function getRankListByOrg4ss(data) {
  return fetchUPlus.post(`${ULSVC}/getRankListByOrg4ss`, data);
}
// 查看奖品
export function getPrize4ss(data) {
  return fetchUPlus.post(`${ULSVC}/getPrize4ss`, data);
}
// 获取活动状态
export function getActivtyStatus(data) {
  return fetchUPlus.post(`${ULSVC}/getActivityStatus`, data);
}

// 分享前调用
export function sharing(data) {
  return fetchUPlus.post("/uplus/sharing/v2/sharing", data);
}

// 活动分享埋点
export function ulActInviteStudyStar(data) {
  return fetchUPlus.post(`${ULSVC}/ulActInviteStudyStar`, data);
}
//我的邀请战绩
export function myInviteRecord(data) {
  return fetchUPlus.post(`${ULSVC}/myInviteRecord`, data);
}

// 获取奖品列表【邀请礼】
export function getprizelist() {
  return fetchUPlus.post(`${PUBLICSVC}/getPrizeList`, { activity_id: "a3680c00600911ed95c500163e147e5f" }
  );
}
// 获取用户积分情况【邀请礼】
export function getuserpoint() {
  return fetchUPlus.post(`${PUBLICSVC}/getUserPoint`, 
   { activity_id: "a3680c00600911ed95c500163e147e5f" }
  );
}

// 兑换奖品【邀请礼】
export function redeemprize(params) {
  return fetchUPlus.post(`${PUBLICSVC}/redeemPrize`, 
    { activity_id: "a3680c00600911ed95c500163e147e5f", ...params}, {
      errorHandler: true
    }
  );
}

// 获取抽奖结果列表
export function getuserdrawprizelist(params) {
  return fetchUPlus.post(`${PUBLICSVC}/getUserDrawPrizeList`, { activity_group_id: "6736c778601511ed95c500163e147e5f", ...params });
}



// WEBPACK FOOTER //
// ./src/gtn/api/uPlusApi/learning.js